import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

export const scaffolderGithubEmuTranslationRef = createTranslationRef({
  id: 'scaffolder-githubemu',
  messages: {
    emailStatusPicker: {
      checkingStatus: 'Checking user status…',
      genericError: 'Could not check this address. Try again in a moment.',
      hint: 'Eligibility is checked when you leave this field.',
      notInVwCore: {
        title:
          '{{email}} was not found in the O365 tenant of Volkswagen Group.',
        description:
          'The user must exist in the VW Group O365 tenant before they can be invited to the CARIAD Azure tenant. ',
        onboardingLink: 'Start onboarding here',
      },
      alreadyInCariad: {
        title: '{{user}} is already onboarded to the CARIAD Azure tenant.',
        description: 'No invitation needed — this user already has access.',
      },
      pendingInvitation: {
        title:
          '{{user}} has been invited to the CARIAD Azure tenant but has not accepted yet.',
        description:
          'To complete the onboarding process, please accept the invitation. If you are not the intended recipient, please forward this link to the correct user: ',
        acceptLink: 'Accept the invitation',
        copyLabel: 'Copy invitation link',
        copiedLabel: 'Link copied',
      },
      available: {
        title:
          '{{email}} is eligible for invitation to the CARIAD Azure tenant.',
      },
    },
    azurePicker: {
      alreadyOnboarded: {
        title: '{{user}} already onboarded to GHEC-EU. No action needed.',
      },
      pendingInvitation: {
        title:
          '{{user}} has been invited to CARIAD Azure tenant but has not accepted the invitation yet.',
      },
      notInTenant: {
        title:
          '{{email}} has not yet been onboarded to the CARIAD Azure tenant and cannot be invited to GitHub until that is completed.',
        onboardingLink: 'Start onboarding here',
      },
    },
  },
});
